/**
 *
 * @param {number | undefined} seconds number of seconds
 * @param {'00:00:00' | '00:00'} pattern output patters. Default 00:00:00
 * @returns {string}
 */
export const convertSecondsToTime = (seconds, pattern = '00:00:00') => {
  if (!seconds || seconds == null || Number.isNaN(seconds)) {
    return pattern;
  }
  let startSubstring = 11;
  if (pattern === '00:00') {
    startSubstring = 14;
  }

  return new Date(seconds * 1000).toISOString().substring(startSubstring, 19);
};

export const isCurrentMonthSelected = (dates, action) =>
  dates.length > 0 &&
  new Date().getMonth() === new Date(dates[0]).getMonth() &&
  action;

export const parseDateSafe = (dateString) => {
  if (!dateString) return undefined;
  try {
    const date = new Date(dateString);
    if (Number.isNaN(date.getTime())) {
      return undefined;
    }

    return date;
  } catch {
    return undefined;
  }
};
